module.exports = __webpack_public_path__ + "static/img/first_team.f4ffd7c5.svg";